import { COLOR_META, LEGEND_ORDER, LEGEND_INTRO } from "@/lib/colors";

// Légende unique : texte d'explication (optionnel) + puces couleur + signification.
// Réutilisée partout où les couleurs sont affichées (tableau enseignant, fiche élève, espace parent).
export function ColorLegend({ showIntro = false, className = "" }) {
  return (
    <div className={className} data-testid="color-legend">
      {showIntro && (
        <p className="mb-2.5 text-xs leading-relaxed text-slate-500 dark:text-slate-400" data-testid="color-legend-intro">
          {LEGEND_INTRO}
        </p>
      )}
      <div className="flex flex-wrap items-center gap-x-4 gap-y-1.5">
        {LEGEND_ORDER.map((key) => {
          const m = COLOR_META[key];
          return (
            <div key={key} className="flex items-center gap-1.5" title={m.meaning} data-testid={`legend-item-${key}`}>
              <span className={`h-3 w-3 shrink-0 rounded-full ${m.dot}`} aria-hidden="true" />
              <span className="text-xs text-slate-500 dark:text-slate-400">{m.meaning}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
